export default class Textarea extends React.PureComponent

  constructor: (props) ->
    super(props)

  render: ->
    <div className="textarea-wrapper">
      { @renderWidthExpander() }

      <TextareaAutosize id={@props.id}
                        value={@props.text}
                        placeholder={@props.placeholder}
                        onChange={@props.onChange} />
    </div>

  # The width-expander is an invisible element that defines
  # the minimum width that will be used by the actual textarea
  renderWidthExpander: ->
    <span className="width-expander">
      {@props.text || @props.placeholder}
    </span>
